import {
  NewPassiveModal as LibPassiveModal,
  NewPassiveModalProps as LibNewPassiveModalProps,
} from "@flaminem/ui-components";
import { FC } from "react";

import { useT } from "src/internationalization";

export type PassiveModalProps = Omit<LibNewPassiveModalProps, "languageTexts">;

export const PassiveModal: FC<PassiveModalProps> = ({ children, ...props }) => {
  const t = useT();

  return (
    <LibPassiveModal
      {...props}
      languageTexts={{
        close: t("general.actions.close"),
      }}
    >
      {children}
    </LibPassiveModal>
  );
};
